import { createSelector } from '@reduxjs/toolkit';
import { selfAppsSelector } from './self';

const appsSelector = createSelector(selfAppsSelector, (apps) => apps.apps);

export default appsSelector;
